module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unbind-box section-white content-padded"
  }, [_c('div', {
    staticClass: "content-center"
  }, [_c('p', [_vm._v("您尚未绑定认证服务号，无法使用该功能。")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toBind
    }
  }, [_vm._v("去绑定")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97dff39a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/empty/unbind.vue
// module id = 977
// module chunks = 30